import{jsx as e}from"react/jsx-runtime";import t from"styled-components";import{Row as o}from"react-styled-flexboxgrid";const i=t.div.withConfig({displayName:"RowWrapper",componentId:"VDS__sc-1n498kw-0"})`
  width: 100%;
`,n=t(o).withConfig({displayName:"StyledRow",componentId:"VDS__sc-1n498kw-1"})`
  max-width: 1272px;
`,r=function(t){return e(i,{bleed:t.bleed,children:e(n,Object.assign({},t,{children:t.children}))})};export{r as default};
